import { Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { UrlConnectionEnum } from "../../enums/connection/url-connection.enum";
import { ModelLocatorService } from "../config/model-locator.service";
import { HttpService } from "../http-service/http.service";

@Injectable()
export class PostService {


    constructor(private httpService: HttpService,
        private domSanitizer: DomSanitizer,
        private modelLocator: ModelLocatorService) {

    }

    /**
     * Gets all posts
     * @author Starley Cazorla
     * @param segmentacao
     * @returns
     */
    async getAllPosts(segmentacao: any) {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(true);

            try {
                this.httpService.post(UrlConnectionEnum.GET_ALL_POSTS, segmentacao, config).subscribe(
                    {
                        next: (data) => {
                            if (data['status'] == 200) {
                                const postsVeiculacao = data['result'];
                                postsVeiculacao.forEach((post) => {
                                    post.youtube = this.domSanitizer.bypassSecurityTrustResourceUrl(post.imagem);
                                });
                                resolve(postsVeiculacao);
                            } else {
                                reject(data['message']);
                            }
                        },
                        error: (error) => {
                            reject(error);
                        }
                    }
                );
            } catch (error) {
                reject(error);
            }
        });
    }


    /**
     * To like post
     * @author Starley Cazorla
     * @param post
     * @param status
     * @returns
     */
    async toLikePost(post: any, status: boolean) {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(true);

            try {

                let novoStatus: boolean;
                let operacao: string;

                if (status == false) {
                    novoStatus = true;
                    operacao = 'update';
                } else if (status == true) {
                    novoStatus = false;
                    operacao = 'update';
                } else {
                    novoStatus = true;
                    operacao = 'insert';
                }

                let postLike = {
                    post: post,
                    operacao: operacao,
                    status: novoStatus,
                    cpf: this.modelLocator.dadosLogin.cpf
                };

                this.httpService.post(UrlConnectionEnum.LIKE_A_POST, postLike, config).subscribe(
                    {
                        next: (data) => {
                            if (data['status'] == 200) {

                                resolve(postLike.status)
                            } else {
                                resolve(data['message']);
                            }
                        },
                        error: (error) => {
                            resolve(error);
                        }
                    }
                );
            } catch (error) {
                reject(error);
            }
        });
    };

    /**
     * Sends new comment
     * @author Starley Cazorla
     * @param formComentario
     * @returns
     */
    async sendNewComment(formComentario: any) {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(true);

            try {
                this.httpService.post(UrlConnectionEnum.SEND_NEW_COMMENT, formComentario, config).subscribe(
                    {
                        next: (data) => {
                            if (data['status'] == 200) {
                                resolve(true);
                            }
                        },
                        error: (error) => {
                            resolve(error);
                        }
                    }
                );
            } catch (error) {
                reject(error);
            }
        });

    };

    /**
     * Gets all post comments
     * @author Starley Cazorla
     * @param post
     * @returns
     */
    async getAllPostComments(post: any) {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(true);

            try {
                this.httpService.get(UrlConnectionEnum.GET_ALL_POST_COMMENTS, post, config).subscribe(
                    {
                        next: (data) => {
                            if (data['status'] == 200) {
                                resolve(data['result']);
                            } else {
                                resolve(data['message']);
                            }
                        },
                        error: (error) => {
                            resolve(error);
                        }
                    }
                );
            } catch (error) {
                reject(error);
            }
        });
    };

}
